import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import localePtExtra from '@angular/common/locales/extra/pt';
import localePt from '@angular/common/locales/pt';

import {
  DEFAULT_COUNTRY_TO_LOCALE_MAP,
  type I18nLanguageCode
} from '@gruposaltaedu/liv-i18n/locale';

export const APP_I18N_SUPPORTED_LANGUAGES = [
  'pt-BR',
  'es-MX',
  'es-CO'
] as const satisfies readonly I18nLanguageCode[];

export const APP_I18N_DEFAULT_LANGUAGE: (typeof APP_I18N_SUPPORTED_LANGUAGES)[number] =
  'pt-BR';

const LOCALE_DATA_FOR_APP_LANGUAGE: Record<
  (typeof APP_I18N_SUPPORTED_LANGUAGES)[number],
  { data: object; extra: object }
> = {
  'pt-BR': { data: localePt, extra: localePtExtra },
  'es-MX': { data: localeEs, extra: localeEsExtra },
  'es-CO': { data: localeEs, extra: localeEsExtra }
};

export const APP_I18N_COUNTRY_TO_LANGUAGE_MAP = {
  ...DEFAULT_COUNTRY_TO_LOCALE_MAP,
  CO: 'es-CO'
} as const satisfies Readonly<
  Record<string, (typeof APP_I18N_SUPPORTED_LANGUAGES)[number]>
>;

export function registerAppI18nLocaleData(): void {
  for (const code of APP_I18N_SUPPORTED_LANGUAGES) {
    const { data, extra } = LOCALE_DATA_FOR_APP_LANGUAGE[code];
    registerLocaleData(data, code, extra);
  }
}

export const PORTFOLIO_API_LOCALE_BY_APP_LANGUAGE: Record<
  (typeof APP_I18N_SUPPORTED_LANGUAGES)[number],
  string
> = {
  'pt-BR': 'pt-BR',
  'es-MX': 'es-MX',
  'es-CO': 'es-CO'
};

export function appLanguageToPortfolioApiLocale(appLang: string): string {
  return (
    PORTFOLIO_API_LOCALE_BY_APP_LANGUAGE[
      appLang as keyof typeof PORTFOLIO_API_LOCALE_BY_APP_LANGUAGE
    ] ?? appLang
  );
}
